(function (factory) {
  'use strict';
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.FFCV3WhatsIncluded) return;
  window.FFCV3WhatsIncluded = api;
  api.listen(document, window);
})(function () {
  'use strict';
  var ROOT = '[data-v3-included]';
  var SELECTOR = '[data-ffc-bundle-transducer-selector]';
  var CONTROL = '[data-ffc-required-transducer]';
  var mounted = new WeakMap();
  var resizeTimer = null;

  function familyForName(name) {
    if (name === 'Choose your 3-in-1 transducer') return '3in1';
    if (name === 'FFS Transducer' || name === 'FFS Live Sonar Transducer') return 'ffs';
    return null;
  }

  function resolveSelections(controls, optionNames) {
    var result = { ffs: null, '3in1': null };
    var seen = { ffs: 0, '3in1': 0 };
    Array.from(controls).forEach(function (control) {
      var index = /^option([1-3])$/.exec(control.dataset.index || '');
      var family = index && familyForName(optionNames[Number(index[1]) - 1]);
      if (!family) return;
      seen[family] += 1;
      var option = control.options[control.selectedIndex];
      var handle = option && option.dataset.ffcGuideHandle;
      result[family] = control.value && option && !option.disabled && typeof handle === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle) ? handle : null;
    });
    Object.keys(seen).forEach(function (family) {
      if (seen[family] !== 1) result[family] = null;
    });
    return result;
  }

  function stateFor(root) {
    if (mounted.has(root)) return mounted.get(root);
    var options;
    try { options = JSON.parse(root.dataset.productOptions || '[]'); } catch (error) { options = []; }
    if (!Array.isArray(options)) options = [];
    var records = new Map();
    root.querySelectorAll('template[data-v3-guide]').forEach(function (template) {
      var handle = template.dataset.v3Guide;
      if (records.has(handle)) records.set(handle, null);
      else records.set(handle, template);
    });
    var cards = Array.from(root.querySelectorAll('[data-v3-family]')).map(function (card) {
      return { element: card, family: card.dataset.v3Family, handle: null, neutral: card.cloneNode(true) };
    });
    var state = { options: options, records: records, cards: cards };
    mounted.set(root, state);
    return state;
  }

  function selectorFor(root, doc) {
    return Array.from(doc.querySelectorAll(SELECTOR)).find(function (selector) {
      return selector.dataset.productId === root.dataset.productId && !selector.closest('[role="dialog"], .modal');
    });
  }

  function replaceCard(card, template, root) {
    var fragment = template ? template.content.cloneNode(true) : card.neutral.cloneNode(true);
    var nodes = Array.from(fragment.childNodes);
    card.element.replaceChildren.apply(card.element, nodes);
    card.element.querySelectorAll('[data-v3-group]').forEach(function (group) {
      group.name = root.id + '-' + card.family;
    });
    card.element.dataset.v3SelectedHandle = card.handle || '';
  }

  function closedHeight(card, root) {
    var clone = card.cloneNode(true);
    var contents = clone.querySelector('.v3-included__body > .v3-included__contents');
    if (contents) contents.open = false;
    clone.querySelectorAll('[data-v3-group]').forEach(function (group) { group.open = false; });
    clone.style.setProperty('--v3-row-closed-height', '0px');
    clone.style.position = 'absolute';
    clone.style.left = '-100000px';
    clone.style.top = '0';
    clone.style.width = card.getBoundingClientRect().width + 'px';
    clone.style.height = 'auto';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.setAttribute('aria-hidden', 'true');
    root.appendChild(clone);
    var height = clone.getBoundingClientRect().height;
    clone.remove();
    return height;
  }

  function equalizeRoot(root) {
    var cards = Array.from(root.querySelectorAll('.v3-included__grid > .v3-included__card'));
    if (root.classList.contains('v3-included--standalone') || cards.length < 2) {
      cards.forEach(function (card) { card.style.removeProperty('--v3-row-closed-height'); });
      return;
    }
    cards.forEach(function (card) { card.style.setProperty('--v3-row-closed-height', '0px'); });
    var rows = [];
    cards.forEach(function (card) {
      var top = card.getBoundingClientRect().top;
      var row = rows.find(function (candidate) { return Math.abs(candidate.top - top) <= 1; });
      if (!row) {
        row = { top: top, cards: [] };
        rows.push(row);
      }
      row.cards.push(card);
    });
    rows.forEach(function (row) {
      var height = Math.max.apply(Math, row.cards.map(function (card) { return closedHeight(card, root); }));
      row.cards.forEach(function (card) { card.style.setProperty('--v3-row-closed-height', height + 'px'); });
    });
  }

  function equalizeAll(doc) {
    doc.querySelectorAll(ROOT).forEach(equalizeRoot);
  }

  function syncRoot(root, doc) {
    var state = stateFor(root);
    if (!state.cards.length) return;
    var selector = selectorFor(root, doc);
    var choices = resolveSelections(selector ? selector.querySelectorAll(CONTROL) : [], state.options);
    state.cards.forEach(function (card) {
      var handle = choices[card.family];
      var template = handle ? state.records.get(handle) : null;
      if (!template) handle = null;
      if (handle === card.handle) return;
      card.handle = handle;
      replaceCard(card, template, root);
    });
  }

  function syncAll(doc) {
    doc.querySelectorAll(ROOT).forEach(function (root) { syncRoot(root, doc); });
    equalizeAll(doc);
  }

  function listen(doc, win) {
    function sync() { syncAll(doc); }
    function settledSync() {
      sync();
      win.setTimeout(sync, 0);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { equalizeAll(doc); });
    }
    doc.addEventListener('change', function (event) {
      if (event.target.matches && event.target.matches(CONTROL)) sync();
    }, true);
    doc.addEventListener('reset', function () { win.setTimeout(sync, 0); }, true);
    doc.addEventListener('toggle', function (event) {
      var group = event.target;
      if (group.matches && group.matches('.v3-included__contents') && group.closest(ROOT)) {
        win.requestAnimationFrame(function () { equalizeAll(doc); });
      }
      if (!group.matches || !group.matches('[data-v3-group]') || !group.open || !group.closest(ROOT)) return;
      group.parentElement.querySelectorAll('[data-v3-group]').forEach(function (other) {
        if (other !== group) other.open = false;
      });
    }, true);
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', settledSync, { once: true });
    else settledSync();
    doc.addEventListener('shopify:section:load', settledSync);
    win.addEventListener('pageshow', settledSync);
    win.addEventListener('resize', function () {
      win.clearTimeout(resizeTimer);
      resizeTimer = win.setTimeout(function () { equalizeAll(doc); }, 80);
    });
  }

  return { familyForName: familyForName, resolveSelections: resolveSelections, syncAll: syncAll, equalizeAll: equalizeAll, listen: listen };
});
